import { createRouter, createWebHashHistory } from 'vue-router';
import HomePage from '../layout/HomePage.vue';
import LoginPage from '../views/LoginPage.vue';
import MeetingList from '../views/MeetingList.vue';
import UserList from '../views/UserList.vue';
import DashBoard from '../views/DashBoard.vue';
import AddMetting from '../views/AddMetting.vue';
import UploadMetting from '../views/UploadMetting.vue';
import UserAdd from '../views/UserAdd.vue';
import MettingOngoing from '../views/MettingOngoing.vue';
import MettingEdit from '../views/MettingEdit.vue';
import DeepSeek from '@/views/DeepSeek.vue';
import AudioOngoing from '@/views/AudioOngoing.vue';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/', component: LoginPage,
            meta: { transition: 'fade' }
        },
        {
            path: '/', component: HomePage,
            children: [
                { 
                    path: '/dashboard', 
                    component: DashBoard,
                    meta: { 
                        transition: 'slide-left',
                        loadingStyle: 'spinner'
                    } 
                },
                { 
                    path: '/deepseek', 
                    component: DeepSeek,
                    meta: { 
                        transition: 'flip',
                        loadingStyle: 'dots'
                    } 
                },
                { 
                    path: '/addmeeting', 
                    component: AddMetting,
                    meta: { 
                        transition: 'slide-up',
                        loadingStyle: 'spinner'
                    } 
                },
                {
                    path: '/meetingedit/:id', 
                    component: MettingEdit, 
                    meta: {
                        active: 'addmeeting',
                        transition: 'zoom',
                        loadingStyle: 'pulse'
                    }
                },
                {
                    path: '/meetingongoing/:id', 
                    component: MettingOngoing, 
                    meta: {
                        active: 'addmeeting',
                        transition: 'slide-up',
                        loadingStyle: 'dots'
                    }
                },
                {
                    path: '/audioongoing/:id', 
                    component: AudioOngoing, 
                    meta: {
                        active: 'addmeeting',
                        transition: 'slide-up',
                        loadingStyle: 'dots'
                    }
                },
                { 
                    path: '/meetinguser', 
                    component: UserList,
                    meta: { 
                        transition: 'fade',
                        loadingStyle: 'spinner'
                    } 
                },
                {
                    path: '/meetinguseradd', 
                    component: UserAdd, 
                    meta: {
                        active: 'meetinguser',
                        transition: 'zoom',
                        loadingStyle: 'pulse'
                    }
                },
                { 
                    path: '/meetings', 
                    component: MeetingList,
                    meta: { 
                        transition: 'zoom',
                        loadingStyle: 'pulse'
                    } 
                },
                { 
                    path: '/upload', 
                    component: UploadMetting,
                    meta: { 
                        transition: 'slide-up',
                        loadingStyle: 'spinner'
                    } 
                },
                { 
                    path: '/questans', 
                    component: () => import('../views/QuestAnswers.vue'),
                    meta: { 
                        transition: 'fade',
                        loadingStyle: 'dots'
                    } 
                },
            ]
        },
    ]
});

export default router;
